import { HamburgerMenuContext } from '@components/organisms/navbar/HamburgerMenuContext';
import { useLogout } from '@hooks/api';
import { ArrowRightIcon, BaseIcon } from '@moreharvest/component-library';
import { clickApply } from '@services/analytics';
import { AnalyticsClickId } from 'mh-client';
import { useContext } from 'react';
import { useNavigate } from 'react-router';

const LogOutBtn = ({
    id = 'topnav_CTA_logOut',
    screenName,
}: {
    id?: string;
    screenName?: string;
}) => {
    const navigate = useNavigate();
    const { setIsOpen } = useContext(HamburgerMenuContext);
    const { mutate: logout } = useLogout();

    return (
        <button
            onClick={() => {
                if (screenName) {
                    clickApply({
                        screen_name: screenName,
                        click_id: AnalyticsClickId.getInstance().LOG_OUT,
                    });
                }
                logout(undefined, {
                    onSettled: () => {
                        setIsOpen(false);
                        navigate('/login');
                    },
                });
            }}
            className="flex items-center gap-x-4 font-semibold Label-Medium cursor-pointer py-3 text-base-black dark:text-base-white"
            id={id}
        >
            <BaseIcon size="small">
                <ArrowRightIcon className="fill-base-black dark:fill-base-white rotate-180" />
            </BaseIcon>
            Log Out
        </button>
    );
};

export default LogOutBtn;
